import React from 'react';

import {
  TextInput,
  Create,
  SimpleForm,
  Show,
  SimpleShowLayout,
  List,
  Edit,
  Datagrid,
  TextField,
  EditButton,
  translate as t,
} from 'admin-on-rest';

export const CourseCategoryList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name.sv" label="SV" />
      <TextField source="name.en" label="EN" />
      <EditButton />
    </Datagrid>
  </List>
));

const CourseCategoryTitle = t(({ record, locale }) => (
  <span>{record ? `${record.name[locale]}` : ''}</span>
));

export const CourseCategoryShow = t((props) => (
  <Show title={<CourseCategoryTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="name.sv" />
      <TextField source="name.en" />
    </SimpleShowLayout>
  </Show>
));

export const CourseCategoryCreate = t((props) => (
  <Create title={props.translate('create.item', { item: props.translate('academy.courseCategory') })} {...props}>
    <SimpleForm>
      <TextInput label={`${props.translate('title')} ${props.translate('swedish')}`} source="name.sv" />
      <TextInput label={`${props.translate('title')} ${props.translate('english')}`} source="name.en" />
    </SimpleForm>
  </Create>
));

export const CourseCategoryEdit = t((props) => (
  <Edit title={<CourseCategoryTitle />} {...props}>
    <SimpleForm>
      <TextInput label={`${props.translate('title')} ${props.translate('swedish')}`} source="name.sv" />
      <TextInput label={`${props.translate('title')} ${props.translate('english')}`} source="name.en" />
    </SimpleForm>
  </Edit>
));
